import { useMutation } from '@apollo/client';
import ExportIcon from '@clearkit/icons/glyphs/Export';
import ListItemIcon from '@material-ui/core/ListItemIcon';

import ToastsContainer from '~/containers/Toasts';

import mutation from './mutation.graphql';

export default function ExportAudience({ audience, onExport }) {
  const [exportAudience] = useMutation(mutation, {
    onCompleted: () => {
      ToastsContainer.addSuccess(
        'Exporting audience',
        "You'll receive the export via email. This can take a few hours.",
      );

      onExport();
    },
    onError: () => {
      ToastsContainer.addError('There was an error exporting this audience.');
    },
    variables: {
      input: {
        id: audience.id,
      },
    },
  });

  return (
    <a
      className="flex items-center"
      onClick={() => {
        exportAudience();
      }}>
      <ListItemIcon>
        <ExportIcon />
      </ListItemIcon>{' '}
      Export audience
    </a>
  );
}

ExportAudience.propTypes = {
  audience: PropTypes.object.isRequired,
  onExport: PropTypes.func.isRequired,
};
